import { useCallback, useMemo, useState } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { getImageSettings } from 'core-components/library/richTextEditor/helpers/imageHelper'
import { insertImage } from 'core-components/library/richTextEditor/helpers/slateHelper'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { TImageSettings } from 'core-components/library/richTextEditor/interface/TImage'

import { TOOLBAR_TITLES } from '../../constants'

import { ImageSettingsDialog } from './ImageSettingsDialog'

interface IProps {
  disabled: boolean
  className?: string
}

export function ImageButton(props: IProps) {
  const [headerVisible, setHeaderVisible] = useState(false)
  const editor = useSlate()

  const onClose = useCallback(() => {
    setHeaderVisible(false)
  }, [])

  const settings = useMemo(() => getImageSettings(), [])

  const addImage = useCallback(
    (settings: TImageSettings) => {
      insertImage(editor, settings)
      onClose()
    },
    [editor, onClose]
  )

  return (
    <>
      <Button
        className={props.className}
        onClick={() => setHeaderVisible(true)}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.UploadImage]}
        disabled={props.disabled || !editor.fileUploadAdapter}
        iconButton={'kbase kbase-image'}
        variant={'text'}
        color={'grey'}
      />
      <ModalDialog
        title={'Upload image'}
        content={() => (
          <ImageSettingsDialog imageSetting={settings} onSave={addImage} onCancel={onClose} />
        )}
        size={'auto'}
        onClose={onClose}
        show={headerVisible}
      />
    </>
  )
}
